/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { chatGetAssistantSessionSummary } from "../funcs/chatGetAssistantSessionSummary.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { AssistantSessionSummary } from "../models/components/assistantsessionsummary.js";
import {
  GetAssistantSessionSummaryRequest,
  GetAssistantSessionSummarySecurity,
} from "../models/operations/getassistantsessionsummary.js";
import { unwrapAsync } from "../types/fp.js";
export type AssistantSessionSummaryQueryData = AssistantSessionSummary;

export function prefetchAssistantSessionSummary(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetAssistantSessionSummaryRequest,
  security?: GetAssistantSessionSummarySecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildAssistantSessionSummaryQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildAssistantSessionSummaryQuery(
  client$: GramCore,
  request: GetAssistantSessionSummaryRequest,
  security?: GetAssistantSessionSummarySecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<AssistantSessionSummaryQueryData>;
} {
  return {
    queryKey: queryKeyAssistantSessionSummary({
      assistantId: request.assistantId,
      from: request.from,
      to: request.to,
      gramSession: request.gramSession,
      gramProject: request.gramProject,
    }),
    queryFn: async function assistantSessionSummaryQueryFn(
      ctx,
    ): Promise<AssistantSessionSummaryQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(chatGetAssistantSessionSummary(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyAssistantSessionSummary(
  parameters: {
    assistantId: string;
    from: Date;
    to: Date;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "chat", "getAssistantSessionSummary", parameters];
}
